import { css } from 'styled-components';
import { CFBaseFieldHelpers } from './styles';
import { CFMixins } from '../../mixins';
import { CFTokens } from '../../tokens';
export const CFBaseSelectFieldStyles = {
    SelectFieldControlNative: css `
    z-index: ${CFBaseFieldHelpers.selectFieldControlZIndex};
  `,
    SelectFieldControlWeb: css `
    z-index: ${CFBaseFieldHelpers.selectFieldControlZIndex};

    &:focus {
      outline-width: 0;
    }
  `,
    SelectFieldFlyout: css `
    box-sizing: border-box;
    padding: ${CFTokens.SPACER.E}px ${CFTokens.SPACER.D}px
      ${CFTokens.SPACER.D}px;
    width: 100%;
    max-width: ${CFBaseFieldHelpers.selectFieldFlyoutMaxWidth};
    display: flex;
    gap: ${CFTokens.SPACER.D}px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: absolute;
    z-index: 10;
    top: ${CFTokens.SPACER.B}px;
    border: ${CFTokens.BORDER.SUBTLE};
    border-radius: ${CFTokens.BORDER_RADIUS.C}px;
    background: ${CFTokens.COLOR.BACKGROUND_DEFAULT};
    box-shadow: ${CFTokens.ELEVATION.C};
  `,
    SelectFieldOptionList: css `
    padding: 0;
    width: 100%;
    display: flex;
    gap: ${CFBaseFieldHelpers.selectFieldOptionListGap}px;
    flex-direction: column;
  `,
    SelectFieldOptionListLabel: css `
    ${CFMixins.typeSpec(CFTokens.TYPE_SPEC.SUBTITLE_2)};
    padding: 0 ${CFTokens.SPACER.D}px;
    flex: 1;
    color: ${CFTokens.COLOR.TEXT_AND_ELEMENT_HINT};
  `,
    SelectFieldOptionListWeb: css `
    overflow: auto;
    ${CFBaseFieldHelpers.selectFieldListHeight};
  `,
    SelectFieldOptionsWrapper: css `
    width: 100%;
    position: relative;
    z-index: 1;
  `,
};
